import { ChatNavBadge } from './ChatNavBadge.js';
import { NavLink, useLocation } from 'react-router-dom';
import { playGameSound } from '../audio.js';
import { playGameHaptic } from '../haptics.js';
import { useAppStore } from '../store.js';
import { primaryNavigationItems } from './primary-navigation.js';
import { DuelNavBadge } from './DuelNavBadge.js';
export function BottomNav() {
  const location = useLocation();
  const adapter = useAppStore((state) => state.adapter);
  const haptics = useAppStore((state) => state.haptics);
  if (
    location.pathname.startsWith('/game/') ||
    location.pathname.startsWith('/path/game/') ||
    location.pathname === '/tutorial'
  )
    return null;
  return (
    <nav className="bottom-nav" aria-label="Основное меню">
      {primaryNavigationItems.map(({ to, label, icon: Icon, tone }) => (
        <NavLink
          aria-label={tone === 'chat' ? label : undefined}
          key={to}
          to={to}
          className={({ isActive }) => `nav-item nav-item-${tone}${isActive ? ' active' : ''}`}
          end={to === '/'}
          onClick={() => {
            if (location.pathname !== to) {
              playGameSound('navigate');
              playGameHaptic(adapter, haptics, 'navigate');
            }
          }}
        >
          <span className="nav-icon-wrap">
            <Icon size={23} />
            {tone === 'duels' ? <DuelNavBadge /> : null}
            {tone === 'chat' ? <ChatNavBadge /> : null}
          </span>
          <span className="nav-label">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
